import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import DemandController from '../../controllers/Demands/DemandController';
import { useAuth } from 'src/contexts/auth';
import classNames from 'classnames';
import { InputMask } from 'primereact/inputmask';

interface filteredProps {
    label: string;
    value?: string;
}

interface filteredDemand {
    label: string;
    value?: number;
}

const EditDemand = () => {
    const { dialogDemand, setDialogDemand, demand, authDemand, setAuthDemand } = useAuth();

    const [submitted, setSubmitted] = useState<boolean>();
    const { getDemandData } = DemandController();
    const { formik, unitys, prioritys, vehicles, managers, stocks, fuels, loading } = getDemandData;

    const [filteredUnity, setFilteredUnity] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [filteredPriority, setFilteredPriority] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [filteredVehicle, setFilteredVehicle] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [filteredManager, setFilteredManager] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [filteredDemand, setFilteredDemand] = useState<filteredDemand[]>([{ label: '', value: 0 }]);
    const [filteredFuels, setFilteredFuels] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [filteredStocks, setFilteredStocks] = useState<filteredProps[]>([{ label: '', value: '' }]);

    const [valueUnity, setValueUnity] = useState('');
    const [valueAuthorized, setValueAuthorized] = useState(0);
    const [valuePriority, setValuePriority] = useState('');
    const [valueVehicle, setValueVehicle] = useState('');
    const [valueManager, setValueManager] = useState('');
    const [valueDemand, setValueDemand] = useState('');
    const [valueStock, setValueStock] = useState('');
    const [valueFuel, setValueFuel] = useState('');
    const [valueIntinerary, setValueIntinerary] = useState('');
    const [valueQuantity, setValueQuantity] = useState(0);
    const [valueDataInicio, setValueDataInicio] = useState('');
    const [valueDataFim, setValueDataFim] = useState('');
    const [description, setDescription] = useState('');
    const [editMode, setEditMode] = useState(false);
   

    //

    const editDemand = { ...demand };

    const [fuelType, setFuelType] = useState<boolean>(false);
    const [registerFinished, setRegisterFinished] = useState(false);

    const searchUnitys = (event: any) => {
        let filteredUnitys;
        if (!event.query.trim().length) {
            filteredUnitys = [...unitys];
        } else {
            filteredUnitys = unitys.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredUnity(filteredUnitys);
    };

    const searchPrioritys = (event: any) => {
        let filteredPrioritys;
        if (!event.query.trim().length) {
            filteredPrioritys = [...prioritys];
        } else {
            filteredPrioritys = prioritys.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredPriority(filteredPrioritys);
    };

    const searchVehicles = (event: any) => {
        let filteredVehicles;
        if (!event.query.trim().length) {
            filteredVehicles = [...vehicles];
        } else {
            filteredVehicles = vehicles.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredVehicle(filteredVehicles);
    };

    const searchManagers = (event: any) => {
        let filteredManagers;
        if (!event.query.trim().length) {
            filteredManagers = [...managers];
        } else {
            filteredManagers = managers.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredManager(filteredManagers);
    };

    const searchStocks = (event: any) => {
        let filteredStocks;
        if (!event.query.trim().length) {
            filteredStocks = [...stocks];
        } else {
            filteredStocks = managers.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredStocks(filteredStocks);
    };

    const searchFuels = (event: any) => {
        let filteredFuels;
        if (!event.query.trim().length) {
            filteredFuels = [...fuels];
        } else {
            filteredFuels = fuels.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredFuels(filteredFuels);
    };

    const demandsType = [
        { label: 'COMBUSTÍVEL', value: 0 },
        { label: 'SERVIÇO', value: 1 },
    ];

    const searchTypesOfDemand = (event: any) => {
        let filteredDemand;
        if (!event.query.trim().length) {
            filteredDemand = [...demandsType];
        } else {
            filteredDemand = demandsType.filter(demand => {
                return demand.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredDemand(filteredDemand);
    };

    useEffect(() => {
        if (dialogDemand === true) {
            // ID
            formik.setFieldValue('ID', demand.ID);
            // ORGAO
            formik.setFieldValue('ORGAOUNIDADEDESTINO', editDemand.ORGAOUNIDADEDESTINO);
            setValueUnity(editDemand.NOME_ORGAOUNIDADEDESTINO);
            //PESSOA
            formik.setFieldValue('PESSOADESTINO', editDemand.PESSOADESTINO);
            setValueManager(editDemand.NOME_PESSOADESTINO);
            // DESCRIÇÃO
            formik.setFieldValue('DESCRICAO', editDemand.DESCRICAO);
            setDescription(editDemand.DESCRICAO);
            // ITINERARIO
            formik.setFieldValue('ITINERARIO', editDemand.ITINERARIO);
            setValueIntinerary(editDemand.ITINERARIO);
            // QUANTIDADE
            formik.setFieldValue('QUANTIDADECOMBUSTIVELSOLICITADO', Number(editDemand.QUANTIDADECOMBUSTIVELSOLICITADO));
            setValueQuantity(Number(editDemand.QUANTIDADECOMBUSTIVELSOLICITADO));
            // DATAINICIO
            formik.setFieldValue('DATAINICIO', editDemand.DATAINICIO);
            setValueDataInicio(editDemand.DATAINICIO);
            // DATAFIM
            formik.setFieldValue('DATAFIM', editDemand.DATAFIM);
            setValueDataFim(editDemand.DATAFIM);
            // ESTOQUE
            formik.setFieldValue('ESTOQUE', editDemand.ID_ESTOQUE);
            setValueStock(editDemand.NOME_ESTOQUE);
            // VEICULO
            formik.setFieldValue('FT_VEICULO', editDemand.FT_VEICULO);
            setValueVehicle(editDemand.NOME_VEICULO);
            // TIPO DE DEMANDA
            formik.setFieldValue('TIPODEMANDA', editDemand.TIPODEMANDA);
            setValueDemand(editDemand.TIPODEMANDA === 0 ? 'COMBUSTÍVEL' : 'SERVIÇO');
            // PRIORIDADE
            const priorityItem = prioritys.find(priority => priority.value === editDemand.PRIORIDADE)?.label || '';
            formik.setFieldValue('PRIORIDADE', editDemand.PRIORIDADE);

            setValuePriority(priorityItem);
            //	FUELS
            const fuelItem = fuels.find(fuel => fuel.value === editDemand.FT_TIPOCOMBUSTIVEL)?.label || '';
            formik.setFieldValue('FT_TIPOCOMBUSTIVEL', editDemand.FT_TIPOCOMBUSTIVEL);
            setValueFuel(fuelItem);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dialogDemand]);

    const hideDialog = () => {
        setSubmitted(false);
        setDialogDemand(false);
        setAuthDemand(false);
    };

    // const editProduct = (product: Props) => {
    // 	setProduct({ ...product });
    // 	setProductDialog(true);
    // };

    const demandEditFooter = (
        <React.Fragment>
            {authDemand ? (
                <>
                    <Button
                        label='Cancelar'
                        icon='pi pi-times'
                        className='p-button-danger p-button-text'
                        onClick={hideDialog}
                    />
                    <Button
                        label='Autorizar Requisição'
                        type='submit'
                        loading={loading}
                        icon='pi pi-check'
                        className='p-button-info p-button-text'
                        disabled={formik.values.QUANTIDADEAUTORIZADA === 0}
                        onClick={() => {
                            console.log("Clicou para autorizar")
                            formik.handleSubmit();
                        }}
                    />
                </>
            ) : (
                <>
                    <Button
                        label='Cancelar'
                        icon='pi pi-times'
                        className='p-button-danger p-button-text'
                        onClick={hideDialog}
                    />
                    <Button
                        type='button'
                        label='Salvar'
                        icon='pi pi-check'
                        className='p-button-success p-button-text'
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                    />
                </>
            )}
        </React.Fragment>
    );

    return (
        <>
            {dialogDemand ? (
                <Dialog
                    visible={dialogDemand}
                    style={{ width: '60vw' }}
                    header='Editar Demanda'
                    modal
                    className='p-grid p-fluid'
                    footer={demandEditFooter}
                    onHide={hideDialog}>
                    <div style={{ height: '100%' }} className='card'>
                        <div className='p-grid'>
                            <div className='p-field p-col-4'>
                                <label htmlFor='descricao'>Unidade</label>
                                <AutoComplete
                                    id='ORGAOUNIDADEDESTINO'
                                    value={valueUnity}
                                    field='label'
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setValueUnity(e.value.label);
                                        formik.setFieldValue(
                                            'ORGAOUNIDADEDESTINO',
                                            filteredUnity.find(unityDest => {
                                                return e.value === unityDest.label;
                                            })?.value || '',
                                        );
                                    }}
                                    onSelect={e => {
                                        setValueUnity(e.value.label);
                                        formik.setFieldValue('ORGAOUNIDADEDESTINO', e.value.value);
                                    }}
                                    suggestions={filteredUnity}
                                    completeMethod={searchUnitys}
                                    dropdown
                                    placeholder='Selecione o setor...'
                                />
                            </div>
                            <div className='p-field p-col-4'>
                                <label htmlFor='descricao'>Responsável</label>
                                <AutoComplete
                                    id='PESSOADESTINO'
                                    value={valueManager}
                                    field='label'
                                    disabled={registerFinished || !valueUnity}
                                    onChange={e => {
                                        setValueManager(e.value.label);
                                        formik.setFieldValue(
                                            'PESSOADESTINO',
                                            filteredManager.find(manager => {
                                                return e.value === manager.label;
                                            })?.value || '',
                                        );
                                    }}
                                    onSelect={e => {
                                        setValueManager(e.value.label);
                                        formik.setFieldValue('PESSOADESTINO', e.value.value);
                                    }}
                                    suggestions={filteredManager}
                                    completeMethod={searchManagers}
                                    dropdown
                                    placeholder='Selecione o Responsável...'
                                />
                                <div
                                    className={classNames('p-invalid popup-fade', {
                                        'popup-form-active':
                                            formik.touched.PESSOADESTINO && formik.errors.PESSOADESTINO,
                                        'popup-form-inactive': !(
                                            formik.touched.PESSOADESTINO && formik.errors.PESSOADESTINO
                                        ),
                                    })}>
                                    {formik.errors.PESSOADESTINO}
                                </div>
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Prioridade</label>
                                <AutoComplete
                                    id='prioridade'
                                    value={valuePriority}
                                    field='label'
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setValuePriority(e.value.label);
                                        formik.setFieldValue(
                                            'PRIORIDADE',
                                            filteredPriority.find(priority => {
                                                return e.value === priority.label;
                                            })?.value || '',
                                        );
                                    }}
                                    onSelect={e => {
                                        setValuePriority(e.value.label);
                                        formik.setFieldValue('PRIORIDADE', e.value.value);
                                    }}
                                    suggestions={filteredPriority}
                                    completeMethod={searchPrioritys}
                                    dropdown
                                    placeholder='Defina a prioridade...'
                                />
                                <div
                                    className={classNames('p-invalid popup-fade', {
                                        'popup-form-active':
                                            formik.touched.PRIORIDADE && formik.errors.PRIORIDADE,
                                        'popup-form-inactive': !(
                                            formik.touched.PRIORIDADE && formik.errors.PRIORIDADE
                                        ),
                                    })}>
                                    {formik.errors.PRIORIDADE}
                                </div>
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Digite a sua demanda:</label>
                                <InputTextarea
                                    autoResize
                                    value={description}
                                    placeholder='Detalhe a sua demanda...'
                                    maxLength={250}
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setDescription(e.target.value);
                                        formik.setFieldValue('DESCRICAO', e.target.value);
                                    }}
                                />
                                <div
                                    className={classNames('p-invalid popup-fade', {
                                        'popup-form-active':
                                            formik.touched.DESCRICAO && formik.errors.DESCRICAO,
                                        'popup-form-inactive': !(
                                            formik.touched.DESCRICAO && formik.errors.DESCRICAO
                                        ),
                                    })}>
                                    {formik.errors.DESCRICAO}
                                </div>
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Tipo da Demanda</label>
                                <AutoComplete
                                    id='TIPODEMANDA'
                                    value={valueDemand}
                                    field='label'
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setValueDemand(e.value.label);
                                        formik.setFieldValue(
                                            'TIPODEMANDA',
                                            filteredDemand.find(demand => {
                                                return e.value === demand.label;
                                            })?.value || '',
                                        );
                                        if (e.value.label === 'COMBUSTÍVEL') {
                                            setFuelType(true);
                                        } else {
                                            setFuelType(false);
                                        }
                                    }}
                                    onSelect={e => {
                                        setValueDemand(e.value.label);
                                        formik.setFieldValue('TIPODEMANDA', e.value.value);
                                    }}
                                    suggestions={filteredDemand}
                                    completeMethod={searchTypesOfDemand}
                                    dropdown
                                    placeholder='Selecione o tipo demanda...'
                                />
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Destino do Intinerário</label>
                                <InputText
                                    type={'text'}
                                    value={valueIntinerary}
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setValueIntinerary(e.target.value);
                                        formik.setFieldValue('ITINERARIO	', e.target.value);
                                    }}
                                    placeholder='Digite seu destino...'
                                />
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Tipo de Combustível</label>
                                <AutoComplete
                                    id='COMBUSTIVEL'
                                    value={valueFuel}
                                    field='label'
                                    disabled={registerFinished}
                                    onChange={e => {
                                        setValueFuel(e.value.label);
                                        formik.setFieldValue(
                                            'FT_TIPOCOMBUSTIVEL',
                                            filteredFuels.find(fuel => {
                                                return e.value === fuel.label;
                                            })?.value || '',
                                        );
                                    }}
                                    onSelect={e => {
                                        setValueFuel(e.value.label);
                                        formik.setFieldValue('FT_TIPOCOMBUSTIVEL', e.value.value);
                                    }}
                                    suggestions={filteredFuels}
                                    completeMethod={searchFuels}
                                    dropdown
                                    placeholder='Tipo de Combustível...'
                                />
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Quantidade solicitada (em Litros)</label>
                                <InputText
                                    type={'number'}
                                    value={valueQuantity}
                                    disabled={registerFinished || !valueFuel}
                                    placeholder='Digite a quantidade solicitada...'
                                    onChange={e => {
                                        if (Number(e.target.value) > 0) {
                                            setValueQuantity(Number(e.target.value));
                                            formik.setFieldValue(
                                                'QUANTIDADECOMBUSTIVELSOLICITADO',
                                                Number(e.target.value),
                                            );
                                        } else {
                                            setValueQuantity(0);
                                            formik.setFieldValue('QUANTIDADECOMBUSTIVELSOLICITADO', 0);
                                        }
                                    }}
                                />
                            </div>



                            {authDemand ? (
                                <div className='p-field p-col-4 p-md-4'>
                                    <label htmlFor='descricao'>Quantidade a autorizar (em Litros)</label>
                                    <InputText
                                        type={'number'}
                                        value={valueAuthorized}
                                        disabled={registerFinished || !valueFuel}
                                        placeholder='Digite a quantidade a autorizar...'
                                        onChange={e => {
                                            if (Number(e.target.value) > 0) {
                                                setValueAuthorized(Number(e.target.value));
                                                formik.setFieldValue('QUANTIDADEAUTORIZADA', Number(e.target.value));
                                            } else {
                                                setValueAuthorized(0);
                                                formik.setFieldValue('QUANTIDADEAUTORIZADA', 0);
                                            }
                                        }}
                                    />
                                </div>
                            ) : null}
                            {authDemand ? null : <div className='p-field p-col-4 p-md-4'></div>}

                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='estoque'>Estoque</label>
                                <div className='p-inputgroup'>
                                    <AutoComplete
                                        disabled={registerFinished}
                                        id='estoque'
                                        dropdown
                                        placeholder='Selecione o estoque...'
                                        value={valueStock}
                                        onChange={e => {
                                            setValueStock(e.value.label);
                                            formik.setFieldValue(
                                                'ESTOQUE',
                                                filteredStocks.find(stock => {
                                                    return e.value === stock.label;
                                                })?.value || '',
                                            );
                                        }}
                                        onSelect={e => {
                                            setValueStock(e.value.label);
                                            formik.setFieldValue('ESTOQUE', e.value.value);
                                        }}
                                        suggestions={filteredStocks}
                                        field='label'
                                        completeMethod={searchStocks}
                                    />
                                </div>
                            </div>
                            <div className='p-field p-col-6 p-md-6'>
                                <label htmlFor='descricao'>Veículo</label>
                                <AutoComplete
                                    id='vehicle'
                                    value={valueVehicle}
                                    field='label'
                                    disabled={registerFinished || !valueStock}
                                    onChange={e => {
                                        setValueVehicle(e.value.label);
                                        formik.setFieldValue(
                                            'FT_VEICULO',
                                            filteredVehicle.find(vehicle => {
                                                return e.value === vehicle.label;
                                            })?.value || '',
                                        );
                                    }}
                                    onSelect={e => {
                                        setValueVehicle(e.value.label);
                                        formik.setFieldValue('FT_VEICULO', e.value.value);
                                    }}
                                    suggestions={filteredVehicle}
                                    completeMethod={searchVehicles}
                                    dropdown
                                    placeholder='Selecione o veículo...'
                                />
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Data Início</label>
                                <InputMask
                                    type={'text'}
                                    mask='99/99/9999'
                                    value={valueDataInicio}
                                    onChange={e => {
                                        setValueDataInicio(e.target.value);
                                        formik.setFieldValue('DATAINICIO', e.target.value);
                                    }}
                                    placeholder='__/__/____'
                                />
                            </div>
                            <div className='p-field p-col-4 p-md-4'>
                                <label htmlFor='descricao'>Data Fim</label>
                                <InputMask
                                    type={'text'}
                                    mask='99/99/9999'
                                    value={valueDataFim}
                                    onChange={e => {
                                        setValueDataFim(e.target.value);
                                        formik.setFieldValue('DATAFIM', e.target.value);
                                    }}
                                    placeholder='__/__/____'
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>
            ) : null}
        </>
    );
};

export default EditDemand;
